import React, { useState, FormEvent, useContext, useEffect } from 'react';
import { Segment, Form, Button, Grid, Input, Table, Select, Container, Icon } from 'semantic-ui-react';
import { ITaskAssignment } from '../../../app/models/taskassignment';
import ProjectStore from '../../../app/stores/projectStore';
import { RootStoreContext } from '../../../app/stores/rootStore';

interface IProps {
  projectId: string;
}

const ImportForm: React.FC<IProps> = ({ projectId }) => {
  const rootStore = useContext(RootStoreContext);
  const {closeModal} = rootStore.modalStore;
  const projectStore = useContext(ProjectStore);
  const {
    taskassignmentRegistry,
    techniciansByName,
    taskassignmentsByCategory,
    assignTechnicianTask,
    loadTaskAssignments,
    projecttaskList,
    importProjectTask,
    createProjectTask,
    loadProjectTasks,
    submitting
  } = projectStore;

  // useEffect(() => {
  //   loadTechnicians();
  //   loadCertificates();

  //   return () => {
  //     fileRegistry.clear();
  //   };
  // }, []);

  const handleSubmit = () => {
    createProjectTask(projecttaskList).then(() => loadProjectTasks(projectId)).then(() => closeModal());
  };
  var i = 0;

  return (
    <Container fluid>
    <Button
          loading={submitting}
          floated='left'
          color='green'
          onClick={handleSubmit}
          content='Submit'
        />
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>No.</Table.HeaderCell>
              <Table.HeaderCell>Item Name</Table.HeaderCell>
              <Table.HeaderCell>Item Description</Table.HeaderCell>
              <Table.HeaderCell>Claimed Qty</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {projecttaskList.map((projecttask) => {
                i = i + 1;
                return     <Table.Row >
                  <Table.Cell>{i}</Table.Cell>
                <Table.Cell>
                   {projecttask.itemName}
                </Table.Cell>
                <Table.Cell>{projecttask.itemDescription}</Table.Cell>
                <Table.Cell>
                {projecttask.orderQty}
                </Table.Cell>
                
              </Table.Row> 
            })}
          </Table.Body>
        </Table>
        </Container>
  );
};

export default ImportForm;
